import InlineMessage from '@ingka/inline-message'
import { useTranslation } from 'react-i18next'

import { Coworker } from 'lib/types/coworker.types'
import { Mission } from 'lib/types/mission.types'

import MissionOverviewCoachingPointers from '../components/MissionOverviewCoachingPointers.component'
import MissionOverviewConnectedMetric from '../components/MissionOverviewConnectedMetric.component'
import MissionOverviewQaProgression from '../components/MissionOverviewQaProgression.component'
import MissionOverviewTitle from '../components/MissionOverviewTitle.component'

import OverviewBase from './OverviewBase.component'

interface Props {
  mission: Mission
  coworker: Coworker
}

const DraftOverview: React.FC<Props> = ({ mission, coworker }) => {
  const { t } = useTranslation()

  return (
    <OverviewBase>
      <MissionOverviewTitle
        missionEnd={mission.changes.endDate}
        qaId={mission.qaId}
        title={mission.changes.title}
      />

      <MissionOverviewCoachingPointers coachingPointers={mission.changes.coachingPointers} />

      <MissionOverviewQaProgression
        mission={mission}
        showChanges={true}
        coworkerId={coworker.legacyId}
      />

      {mission.metricId ? (
        <MissionOverviewConnectedMetric
          metricId={mission.metricId}
          coworker={coworker}
          mission={mission}
          missionEnd={mission.changes.endDate}
        />
      ) : (
        <InlineMessage variant="informative" title={t('features.mission.preview.no-metric')} />
      )}
    </OverviewBase>
  )
}

export default DraftOverview
